import {getConfig,workerList} from '@/assets/js/api/faultRepair'
const faultRepair = {
  state: {
    config:{jdr:''},
    workers:[]
  },
  actions: {
    GetConfig ({ commit }) {
      getConfig().then(response => {
        commit('SET_CONFIG', response.data.data)
      })
    },
    GetWorkerList({ commit }) {
      workerList().then(response => {
        response.data.data.map(m=>{
          m.value = m.guid
        })
        commit('SET_WORKERS', [response.data.data])
      })
    }
  },
  mutations: {
    SET_CONFIG (state, config) {
      state.config = config
    },
    SET_WORKERS(state, workers) {
      state.workers = workers
    }
  },
  namespaced: true
}

export default faultRepair



// WEBPACK FOOTER //
// ./src/store/modules/faultRepair.js